import { create } from "zustand";

export interface UserProfile {
  id: string;
  email: string;
  name: string | null;
  picture: string | null;
}

interface AuthState {
  user: UserProfile | null;
  isLoading: boolean;
  setUser: (user: UserProfile | null) => void;
  setLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: true, // Start as true so we can check session on load
  setUser: (user) => set({ user }),
  setLoading: (isLoading) => set({ isLoading }),
}));
